import { FC } from 'react';
import { Button, Link, SxProps, Theme } from '@mui/material';
import { ExternalLink } from '@barracuda/shared';
import { FooterLink, LinkKind, resolveFooterPath } from '@/hooks/footerLinks';
import { useAppContext } from '@/context/App.context';
import { LocalizedNavLink } from '../LocalizedNavLink/LocalizedNavLink';
import { footerActionButton } from './Footer.styles';

export const FooterLinkItem: FC<{ link: FooterLink; sx: SxProps<Theme> }> = ({ link, sx }) => {
  const { isLoggedIn, language } = useAppContext();

  if (link.kind === LinkKind.ACTION) {
    return (
      <Button
        type='button'
        variant='text'
        onClick={link.onClick}
        sx={{ ...footerActionButton, ...sx }}
      >
        {link.label}
      </Button>
    );
  }

  if (link.kind === LinkKind.EXTERNAL) {
    return (
      <ExternalLink href={link.href} sx={sx}>
        {link.label}
      </ExternalLink>
    );
  }

  const to = resolveFooterPath(link.segment, isLoggedIn);

  if (link.newTab) {
    return (
      <ExternalLink href={`/${language}${to}`} sx={sx}>
        {link.label}
      </ExternalLink>
    );
  }

  return (
    <Link component={LocalizedNavLink} to={to} underline='none' sx={sx}>
      {link.label}
    </Link>
  );
};
